import React, { VFC } from 'react'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'

type ToggleDropDownIconProps = {
    type: 'SMALL' | 'DEFAULT'
    open: boolean
}

const ToggleDropDownIcon: VFC<ToggleDropDownIconProps> = ({ open, type }) => {
    if (type === 'SMALL') {
        return (
            <FontelloIcon
                name={open ? 'dropup-arrow-active' : 'dropdown-arrow-active'}
                fontSize={9}
                color="keshi-3"
                paddingBottom={1}
            />
        )
    }
    return <FontelloIcon name={open ? 'scroll-top' : 'scroll-bottom'} fontSize={9} color="onyx" />
}

export default ToggleDropDownIcon
